export default "__VITE_ASSET__fb980431__"